const bible = require('./voiceJobs.json');
const legacySermon = require('./sermonVoiceJob.json');
const addedSermons = require('./sermonVoiceJobs.json');
const contracts = require('./voiceJobContracts.json');
const sermons = [addedSermons.find(job => job.slug === legacySermon.slug) || legacySermon,
  ...addedSermons.filter(job => job.slug !== legacySermon.slug)];
module.exports = [
  ...bible.map(job => ({ ...job, kind: 'bible', title: `【案件】エゼキエル書 ${job.label} 声優募集`, path: `/jobs/ezekiel/${job.slug}`, imageKey: `ezekiel-${job.slug}`, sourcePath: `/bible/ezekiel/${job.chapter}/1?type=norm` })),
  ...sermons.map(sermon => ({ ...sermon, kind: 'sermon', title: `${sermon.status === 'fulfilled' ? '【取引成立】' : '【案件】'}説教「${sermon.label}」${sermon.status === 'fulfilled' ? '朗読依頼' : '声優募集'}`, path: `/jobs/sermon/${sermon.slug}`, imageKey: sermon.slug, sourcePath: `/sermon/${sermon.slug}` })),
].map(job => {
  const contract = contracts[job.slug];
  if (!contract) return job;
  if (contract.status !== 'fulfilled' || typeof contract.voiceActor !== 'string' || !contract.voiceActor.trim()) {
    throw Error(`契約済み案件には担当声優名が必要です: ${job.slug}`);
  }
  return {
    ...job,
    ...contract,
    title: job.title.replace('【案件】', '【取引成立】').replace(/声優募集$/, '朗読依頼'),
  };
});
